import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/layout';
import Seo from '../components/seo';

import { textPageStatik } from '../db/textPageStatik';
import TextPage from '../components/Pages/TextPage/TextPage';
import { CrumbsNav } from '../components/Pages/About';

const termsPage = ({data}) => {
  return (
    <Layout>
      <Seo title={'Terms of use'} />
      <TextPage textData={data.strapiTermsOfUse} />
      <CrumbsNav crumbsData={textPageStatik.crumbs_nav_terms} />
    </Layout>
  );
};

export default termsPage;

export const query = graphql`
  query($language: String!) {
    strapiTermsOfUse {
      title_ua
      title_ru
      sub_title_ua
      sub_title_ru
      content_ua
      content_ru
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
